export type Brand = {
  name: string
  alt: string
  src: string
  /** Set true when the logo art is white/very light and needs a dark card. */
  dark?: boolean
}

export type BrandGroup = {
  heading: string
  description: string
  brands: Brand[]
}

// IMPLEMENTATION NOTE (not customer-facing):
// For the final WebsiteForge site, these logos should be downloaded and hosted
// locally (preferably in /uploaded/images/brands/) rather than hot-linked.

export const brandGroups: BrandGroup[] = [
  {
    heading: 'Firearms',
    description:
      'Shotguns, rifles, handguns, and rimfires from manufacturers our customers already know and trust — available to compare side by side in-store.',
    brands: [
      {
        name: 'Benelli',
        alt: 'Benelli logo',
        src: 'https://www.benelliusa.com/sites/default/files/styles/large/public/content/images/2024-07/Benelli%20Logo%204Color.jpg?itok=Qv_wvieB',
      },
      {
        name: 'Franchi',
        alt: 'Franchi logo',
        src: 'https://www.franchiusa.com/sites/default/files/styles/large/public/content/images/2021-08/franchi-logo-black-no-tagline.jpeg?itok=uEqJPXJf',
      },
      {
        name: 'Stoeger',
        alt: 'Stoeger logo',
        src: 'https://stoegerindustries.com/sites/default/files/styles/large/public/content/images/2022-05/Stoeger.Logo_.PMS302.PMS172.NoTag__0.jpg?itok=yMApJOam',
      },
      {
        name: 'Uberti',
        alt: 'Uberti logo',
        src: 'https://www.uberti-usa.com/sites/default/files/styles/large/public/content/images/2024-02/uberti-notag.jpg?itok=je1hSD80',
      },
      {
        name: 'Beretta',
        alt: 'Beretta logo',
        src: 'https://dam.beretta.com/etc.clientlibs/beretta/clientlibs/clientlib-site/resources/images/logos/Full__Blue.svg',
      },
      {
        name: 'Tikka',
        alt: 'Tikka logo',
        src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Tikka_logo.svg/250px-Tikka_logo.svg.png',
      },
      {
        name: 'Sako',
        alt: 'Sako logo',
        src: 'https://upload.wikimedia.org/wikipedia/en/thumb/0/04/SAKO_Limited_logo.svg/250px-SAKO_Limited_logo.svg.png',
      },
      {
        name: 'Browning',
        alt: 'Browning logo',
        src: 'https://www.browning.com/etc/clientlibs/bwna/main/images/thebestthereis-blk.png',
      },
      {
        name: 'Winchester',
        alt: 'Winchester firearms logo',
        src: 'https://www.winchesterguns.com/etc/clientlibs/bwna/main/images/winchester/WinchesterLogo1507-compressed-inhansed.png',
      },
      {
        name: 'Volquartsen',
        alt: 'Volquartsen logo',
        src: 'https://assets.volquartsen.com/assets/logo-7a2496b1.svg',
      },
      {
        name: 'Seekins Precision',
        alt: 'Seekins Precision logo',
        src: 'https://www.seekinsprecision.com/images/icon_inline_with_tagline_colored_white.png',
        dark: true,
      },
      {
        name: 'Rock River Arms',
        alt: 'Rock River Arms logo',
        src: 'https://upload.wikimedia.org/wikipedia/en/7/7c/Rock_River_Arms_logo.png',
      },
    ],
  },
  {
    heading: 'Optics',
    description:
      'Hunting and shooting sports optics, including thermal — try the units in person before you commit.',
    brands: [
      {
        name: 'Pulsar',
        alt: 'Pulsar logo',
        src: 'https://pulsarvision.com/app/themes/sage/public/images/logo-w.d61da1.svg',
        dark: true,
      },
      {
        name: 'Vortex',
        alt: 'Vortex Optics logo',
        src: 'https://upload.wikimedia.org/wikipedia/en/thumb/2/2e/Vortex_Optics_logo.png/250px-Vortex_Optics_logo.png',
      },
    ],
  },
  {
    heading: 'Ammunition',
    description:
      'Hunting, target, and defensive ammunition in popular calibers — stocked on the shelf, not just on a screen.',
    brands: [
      {
        name: 'Federal Ammunition',
        alt: 'Federal Ammunition logo',
        src: 'https://upload.wikimedia.org/wikipedia/en/thumb/c/cd/Federal_Premium_Ammunition_logo.svg/250px-Federal_Premium_Ammunition_logo.svg.png',
      },
      {
        name: 'Winchester Ammunition',
        alt: 'Winchester Ammunition logo',
        src: 'https://winchester.com/images/Consumer/logo.png',
      },
    ],
  },
]
